import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Users, Star, MessageCircle } from 'lucide-react';

const items = [
  { icon: ShieldCheck, title: 'Proven Systems', copy: 'Built on experience. Backed by results.' },
  { icon: Users, title: 'Thousands Helped', copy: 'Players and clients across the country.' },
  { icon: Star, title: 'Results That Last', copy: 'Performance, confidence, and habits for life.' },
  { icon: MessageCircle, title: 'Online Coaching', copy: 'Train anywhere. Get better everywhere.' },
];

export const CredibilityStrip = () => {
  return (
    <section id="results" data-testid="credibility-strip" className="bg-black py-16 px-6">
      <div className="container mx-auto max-w-6xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4 lg:divide-x lg:divide-neutral-900">
        {items.map((item, i) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-40px' }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            data-testid={`credibility-item-${i}`}
            className="flex items-start gap-4 lg:px-6"
          >
            <item.icon className="w-8 h-8 text-gray-300 shrink-0 mt-1" strokeWidth={1.5} />
            <div>
              <h3 className="text-white font-bold text-sm tracking-widest uppercase mb-1">{item.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{item.copy}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
